'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const InvoiceIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="InvoiceIcon">
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.28071 5.28099C7.29002 3.27168 10.0153 2.14286 12.8569 2.14286H51.4283C49.7234 2.14286 48.088 2.82015 46.8824 4.02575C45.6769 5.23132 44.9997 6.86649 44.9997 8.57143V55.7143C44.9997 56.5046 44.5647 57.2306 43.8679 57.6034C43.171 57.9763 42.3258 57.9356 41.6682 57.4972L33.214 51.861L24.7598 57.4972C24.04 57.9772 23.1023 57.9772 22.3825 57.4972L13.9283 51.861L5.47408 57.4972C4.81652 57.9356 3.97108 57.9763 3.27431 57.6034C2.57754 57.2306 2.14258 56.5046 2.14258 55.7143V12.8571C2.14258 10.0155 3.2714 7.2903 5.28071 5.28099Z"
          fill="#D8DCE5"
        />
        <path
          d="M46.8827 4.02575C45.6771 5.23132 45 6.86649 45 8.57143V23.5714H55.7143C56.8976 23.5714 57.8571 22.612 57.8571 21.4286V8.57143C57.8571 6.86649 57.18 5.23132 55.9744 4.02575C54.7689 2.82015 53.1334 2.14286 51.4286 2.14286C49.7237 2.14286 48.0883 2.82015 46.8827 4.02575Z"
          fill="#5073C3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.375 16.25C22.4766 16.25 20.656 17.0041 19.3137 18.3465C17.9713 19.6888 17.2172 21.5094 17.2172 23.4078V26.4707H14.5474C13.4167 26.4707 12.5 27.3873 12.5 28.5181C12.5 29.6488 13.4167 30.5655 14.5474 30.5655H17.2172V32.6262L14.4709 36.8334C14.0601 37.4627 14.0271 38.2665 14.3849 38.9274C14.7427 39.5883 15.4338 40 16.1853 40H29.4853C30.6161 40 31.5328 39.0833 31.5328 37.9526C31.5328 36.8218 30.6161 35.9052 29.4853 35.9052H19.9669L20.9791 34.3545C21.1964 34.0217 21.3121 33.6328 21.3121 33.2353V30.5655H23.9819C25.1127 30.5655 26.0293 29.6488 26.0293 28.5181C26.0293 27.3873 25.1127 26.4707 23.9819 26.4707H21.3121V23.4078C21.3121 22.5954 21.6348 21.8163 22.2092 21.242C22.7836 20.6675 23.5626 20.3448 24.375 20.3448C25.1873 20.3448 25.9664 20.6675 26.5408 21.242C27.1152 21.8163 27.4379 22.5954 27.4379 23.4078V24.5871C27.4379 25.7178 28.3546 26.6345 29.4853 26.6345C30.6161 26.6345 31.5328 25.7178 31.5328 24.5871V23.4078C31.5328 21.5094 30.7786 19.6888 29.4363 18.3465C28.094 17.0041 26.2734 16.25 24.375 16.25Z"
          fill="#5073C3"
        />
      </svg>
    </SvgIcon>
  )
}

InvoiceIcon.propTypes = {
  sx: PropTypes.object
}
